import { usePromotions } from "./usePromotions.tsx";
import { usePromotionFetcher } from "./promotions.ts";
import { useCallback, useMemo } from "react";

export function usePromotionReturn(vbid: string) {
  const { getPromotion } = usePromotions();
  const returnPromotionFetcher = usePromotionFetcher();

  const promotion = useMemo(() => getPromotion(vbid), [getPromotion, vbid]);

  const returnPromotion = useCallback(() => {
    return returnPromotionFetcher.submit(
      {},
      {
        action: `/actions/promotion/return/${vbid}`,
        method: "PUT",
      }
    );
  }, [returnPromotionFetcher, vbid]);

  return {
    promotion,
    returnPromotionFetcher,
    returnPromotion,
    isActive: promotion?.active,
  };
}
